import React from "react";

const MenuButton = (props) => {
  return (
    <div {...props}>
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
};

export default MenuButton;
